<template>
  <div class="container" v-if="DialogShow">
    <div class="card">
      <van-dialog v-model="DialogShow" :title="contForm.custSource==2?'添加渠道执行垫款信息':'添加执行垫款信息'" width="95%" style="height:80%" class="editClue" show-cancel-button>
        <van-form ref="form" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
          <van-collapse v-model="activeNames">
            <van-collapse-item name="0">
              <template #title>
                <span class="van-collaps-title">合同信息</span>
              </template>
              <div class="list-wrap van-hairline--top">
                <div class="item" >
                  <span class="key">合同名称：</span>
                  <span class="value">{{ contForm.contractName }}</span>
                </div>
                <div class="item" >
                  <span class="key">合同编号：</span>
                  <span class="value">{{ contForm.contractNum }}</span>
                </div>
                <div class="item" >
                  <span class="key">执行时间：</span>
                  <span class="value">{{ contForm.startTime }}至{{ contForm.endTime }}</span>
                </div>
                <div class="item" >
                  <span class="key">收款单位：</span>
                  <span class="value">{{contForm.companyName}}</span>
                </div>
                <div class="item" style="width: 48%">
                  <span class="key">垫款方式：</span>
                  <span class="value">{{formatHandel('payType',contForm.payType)}}</span>
                </div>
                <div class="item" style="width: 48%">
                  <span class="key">框架类型：</span>
                  <span class="value">{{formatHandel('frameType',contForm.frameType)}}</span>
                </div>
                <div class="item" style="width: 48%">
                  <span class="key">客户来源：</span>
                  <span class="value">{{formatHandel('custSource',contForm.custSource)}}</span>
                </div>
                <!-- <div class="item" v-if="contForm.payType == '1'">
                  <span class="key">部门临时垫款总额度(元)：</span>
                  <span class="value">￥{{amountTotal}}</span>
                </div>
                <div class="item" v-if="contForm.payType == '1'">
                  <span class="key">大写：</span>
                  <span class="value"><span class="bigMoney">{{toChineseBig(amountTotal)}}</span></span>
                </div>
                <div class="item" v-if="contForm.payType == '1'">
                  <span class="key">累计部门临时垫款总额(元)：</span>
                  <span class="value">￥{{amountTotalAdd}}</span>
                </div>
                <div class="item" v-if="contForm.payType == '1'">
                  <span class="key">大写：</span>
                  <span class="value"><span class="bigMoney">{{toChineseBig(amountTotalAdd)}}</span></span>
                </div>
                <div class="item" v-if="contForm.payType == '1'">
                  <span class="key">剩余部门临时授信总额(元)：</span>
                  <span class="value">￥{{amountTotal - amountTotalAdd}}</span>
                </div>
                <div class="item" v-if="contForm.payType == '1'">
                  <span class="key">大写：</span>
                  <span class="value"><span class="bigMoney">{{amountTotal - amountTotalAdd > 0?toChineseBig(amountTotal - amountTotalAdd):'负' + toChineseBig(Math.abs(amountTotal - amountTotalAdd))}}</span></span>
                </div> -->
                <template v-if="contForm.custSource == 1">
                  <!-- <div class="item" v-if="contForm.payType == '2'">
                    <span class="key">合同授信总额(元)：</span>
                    <span class="value">￥{{contForm.advancesMoney}}</span>
                  </div>
                  <div class="item" v-if="contForm.payType == '2'">
                    <span class="key">大写：</span>
                    <span class="value"><span class="bigMoney">{{toChineseBig(contForm.advancesMoney)}}</span></span>
                  </div>
                  <div class="item" v-if="contForm.payType == '2'">
                    <span class="key">累计垫款未回款(元)：</span>
                    <span class="value">￥{{contForm.noReturnedMoney}}</span>
                  </div>
                  <div class="item" v-if="contForm.payType == '2'">
                    <span class="key">大写：</span>
                    <span class="value"><span class="bigMoney">{{toChineseBig(contForm.noReturnedMoney)}}</span></span>
                  </div>
                  <div class="item" v-if="contForm.payType == '2'">
                    <span class="key">剩余授信金额(元)：</span>
                    <span class="value">￥{{(contForm.advancesMoney - contForm.noReturnedMoney)}}</span>
                  </div>
                  <div class="item" v-if="contForm.payType == '2'">
                    <span class="key">大写：</span>
                    <span class="value"><span class="bigMoney">{{contForm.advancesMoney - contForm.noReturnedMoney>0?toChineseBig(contForm.advancesMoney - contForm.noReturnedMoney):'负' + toChineseBig(Math.abs(contForm.advancesMoney - contForm.noReturnedMoney))}}</span></span>
                  </div>
                  <div class="item" >
                    <span class="key">授信账期：</span>
                    <span class="value">{{contForm.creditCycleType?`${contForm.creditCycleValue}个${formatHandel('creditCycleType',contForm.creditCycleType)}`:'--'}}</span>
                  </div>
                  <div class="item">
                    <span class="key">冻结授信额度(元)：</span>
                    <span class="value">￥{{(contForm.advancesMoneyLock)}}</span>
                  </div>
                  <div class="item">
                    <span class="key">大写：</span>
                    <span class="value"><span class="bigMoney">{{toChineseBig(contForm.advancesMoneyLock)}}</span></span>
                  </div> -->
                  <div class="item" >
                    <span class="key">合同逾期状态：</span>
                    <span class="value">
                      <van-tag type="warning" size="mini" v-if="isJudge">逾期</van-tag>
                      <van-tag type="success" size="mini" v-else>正常</van-tag>
                    </span>
                  </div>
                </template>
                <template v-if="contForm.custSource == 2 && form.execCustomerId">
                  <!-- <div class="item" v-if="contForm.payType == '2'">
                    <span class="key">合同授信总额(元)：</span>
                    <span class="value">￥{{advancesInfo.advancesMoney}}</span>
                  </div>
                  <div class="item" v-if="contForm.payType == '2'">
                    <span class="key">大写：</span>
                    <span class="value"><span class="bigMoney">{{toChineseBig(advancesInfo.advancesMoney)}}</span></span>
                  </div>
                  <div class="item" v-if="contForm.payType == '2'">
                    <span class="key">累计垫款未回款(元)：</span>
                    <span class="value">￥{{advancesInfo.noReturnedMoney}}</span>
                  </div>
                  <div class="item" v-if="contForm.payType == '2'">
                    <span class="key">大写：</span>
                    <span class="value"><span class="bigMoney">{{toChineseBig(advancesInfo.noReturnedMoney)}}</span></span>
                  </div>
                  <div class="item" v-if="contForm.payType == '2'">
                    <span class="key">剩余授信金额(元)：</span>
                    <span class="value">￥{{(advancesInfo.advancesMoney - advancesInfo.noReturnedMoney)}}</span>
                  </div>
                  <div class="item" v-if="contForm.payType == '2'">
                    <span class="key">大写：</span>
                    <span class="value"><span class="bigMoney">{{advancesInfo.advancesMoney - advancesInfo.noReturnedMoney>0?toChineseBig(advancesInfo.advancesMoney - advancesInfo.noReturnedMoney):'负' + toChineseBig(Math.abs(advancesInfo.advancesMoney - advancesInfo.noReturnedMoney))}}</span></span>
                  </div>
                  <div class="item" >
                    <span class="key">授信账期：</span>
                    <span class="value">{{advancesInfo.creditCycleType?`${advancesInfo.creditCycleValue}个${formatHandel('creditCycleType',advancesInfo.creditCycleType)}`:'--'}}</span>
                  </div>
                  <div class="item">
                    <span class="key">冻结授信额度(元)：</span>
                    <span class="value">￥{{(advancesInfo.advancesMoneyLock)}}</span>
                  </div>
                  <div class="item">
                    <span class="key">大写：</span>
                    <span class="value"><span class="bigMoney">{{toChineseBig(advancesInfo.advancesMoneyLock)}}</span></span>
                  </div> -->
                  <div class="item" >
                    <span class="key">合同逾期状态：</span>
                    <span class="value">
                      <van-tag type="warning" size="mini" v-if="isJudge">逾期</van-tag>
                      <van-tag type="success" size="mini" v-else>正常</van-tag>
                    </span>
                  </div>
                </template>
              </div>
              <!-- <van-field readonly clickable v-model="form.contractName" @click="id?'':showContList()" label="合同名称" :rules="[{ required: true }]" placeholder="请选择合同名称" required />
              <van-field v-model="form.contractNum" label="合同编号" disabled placeholder="请先选择合同名称" />
              <van-field v-model="form.companyName" label="收款单位" disabled placeholder="请先选择合同名称" /> -->
            </van-collapse-item>
            <van-collapse-item title="合同(执行客户)授信额度" name="1">
              <template #title>
                <span class="van-collaps-title">合同(执行客户)授信额度</span>
              </template>
              <template v-if="advancesCredit.creditTotalMoney">
                <div class="table" style="margin-top: 15px;">
                  <div class="t_left">
                    <div class="td">临时授信总额</div>
                    <div class="tb">{{ advancesCredit.creditTotalMoney }}</div>
                  </div>
                  <div class="t_right">
                    <div class="td">临时授信剩余</div>
                    <div class="tb">{{ advancesCredit.creditResidueMoney }}</div>
                  </div>
                </div>
                <div class="table">
                  <div class="t_right">
                    <div class="td">垫款总额</div>
                    <div class="tb">{{ advancesCredit.advancesTotalMoney }}</div>
                  </div>
                </div>
                <div class="table">
                  <div class="t_left">
                    <div class="td">垫款已还款</div>
                    <div class="tb">{{ advancesCredit.advancesYesReturnedMoney }}</div>
                  </div>
                  <div class="t_right">
                    <div class="td">垫款未还款</div>
                    <div class="tb" style="color: #ee0a24">{{ advancesCredit.advancesNoReturnedMoney }}</div>
                  </div>
                </div>
                <div class="table">
                  <div class="t_right">
                    <div class="td">临时垫款总额</div>
                    <div class="tb">{{ advancesCredit.advancesTempTotalMoney }}</div>
                  </div>
                </div>
                <div class="table">
                  <div class="t_left">
                    <div class="td">临时垫款已还款</div>
                    <div class="tb">{{ advancesCredit.tempYesReturnedMoney }}</div>
                  </div>
                  <div class="t_right">
                    <div class="td">临时垫款未还款</div>
                    <div class="tb">{{ advancesCredit.tempNoReturnedMoney }}</div>
                  </div>
                </div>
                <div class="table">
                  <div class="t_left">
                    <div class="td">临时冻结额度</div>
                    <div class="tb">{{ advancesCredit.freezeTempMoney }}</div>
                  </div>
                  <div class="t_right">
                    <div class="td">临时可充值</div>
                    <div class="tb">{{ advancesCredit.tempRechargeRemainMoney }}</div>
                  </div>
                </div>
                <div class="table">
                  <div class="t_right">
                    <div class="td">长期垫款总额</div>
                    <div class="tb">{{ advancesCredit.advancesLoteTotalMoney }}</div>
                  </div>
                </div>
                <div class="table">
                  <div class="t_left">
                    <div class="td">长期垫款已还款</div>
                    <div class="tb">{{ advancesCredit.loteYesReturnedMoney }}</div>
                  </div>
                  <div class="t_right">
                    <div class="td">长期垫款未还款</div>
                    <div class="tb">{{ advancesCredit.loteNoReturnedMoney }}</div>
                  </div>
                </div>
                <div class="table">
                  <div class="t_left">
                    <div class="td">长期冻结额度</div>
                    <div class="tb">{{ advancesCredit.freezeLoteMoney }}</div>
                  </div>
                  <div class="t_right">
                    <div class="td">长期可充值</div>
                    <div class="tb">{{ advancesCredit.loteRechargeRemainMoney }}</div>
                  </div>
                </div>
                <div class="table">
                  <div class="t_left">
                    <div class="td">特批垫款总额</div>
                    <div class="tb">{{ advancesCredit.advancesSpapTotalMoney }}</div>
                  </div>
                  <div class="t_right">
                    <div class="td">特批可充值</div>
                    <div class="tb">{{ advancesCredit.spapRechargeRemainMoney }}</div>
                  </div>
                </div>
                <div class="table">
                  <div class="t_left">
                    <div class="td">特批垫款已还款</div>
                    <div class="tb">{{ advancesCredit.spapYesReturnedMoney }}</div>
                  </div>
                  <div class="t_right">
                    <div class="td">特批垫款未还款</div>
                    <div class="tb">{{ advancesCredit.spapNoReturnedMoney }}</div>
                  </div>
                </div>
                <div class="table">
                  <div class="t_right">
                    <div class="td">累计可充值金额</div>
                    <div class="tb">{{ advancesCredit.totalRechargeRemainMoney }}</div>
                  </div>
                </div>
              </template>
              <Empty v-else></Empty>
            </van-collapse-item>
            <van-collapse-item title="部门授信额度" name="2">
              <template #title>
                <span class="van-collaps-title">部门授信额度</span>
              </template>
              <template v-if="deptAdvancesData.creditTotalMoney">
                <div class="table" style="margin-top: 15px;">
                  <div class="t_left">
                    <div class="td">临时授信总额</div>
                    <div class="tb">{{ deptAdvancesData.creditTotalMoney }}</div>
                  </div>
                  <div class="t_right">
                    <div class="td">临时授信剩余</div>
                    <div class="tb">{{ deptAdvancesData.creditResidueMoney }}</div>
                  </div>
                </div>
                <div class="table">
                  <div class="t_right">
                    <div class="td">垫款总额</div>
                    <div class="tb">{{ deptAdvancesData.advancesTotalMoney }}</div>
                  </div>
                </div>
                <div class="table">
                  <div class="t_left">
                    <div class="td">垫款已还款</div>
                    <div class="tb">{{ deptAdvancesData.advancesYesReturnedMoney }}</div>
                  </div>
                  <div class="t_right">
                    <div class="td">垫款未还款</div>
                    <div class="tb" style="color: #ee0a24">{{ deptAdvancesData.advancesNoReturnedMoney }}</div>
                  </div>
                </div>
                <div class="table">
                  <div class="t_right">
                    <div class="td">临时垫款总额</div>
                    <div class="tb">{{ deptAdvancesData.advancesTempTotalMoney }}</div>
                  </div>
                </div>
                <div class="table">
                  <div class="t_left">
                    <div class="td">临时垫款已还款</div>
                    <div class="tb">{{ deptAdvancesData.tempYesReturnedMoney }}</div>
                  </div>
                  <div class="t_right">
                    <div class="td">临时垫款未还款</div>
                    <div class="tb">{{ deptAdvancesData.tempNoReturnedMoney }}</div>
                  </div>
                </div>
                <div class="table">
                  <div class="t_left">
                    <div class="td">临时冻结额度</div>
                    <div class="tb">{{ deptAdvancesData.freezeTempMoney }}</div>
                  </div>
                  <div class="t_right">
                    <div class="td">临时可充值</div>
                    <div class="tb">{{ deptAdvancesData.tempRechargeRemainMoney }}</div>
                  </div>
                </div>
                <div class="table">
                  <div class="t_right">
                    <div class="td">长期垫款总额</div>
                    <div class="tb">{{ deptAdvancesData.advancesLoteTotalMoney }}</div>
                  </div>
                </div>
                <div class="table">
                  <div class="t_left">
                    <div class="td">长期垫款已还款</div>
                    <div class="tb">{{ deptAdvancesData.loteYesReturnedMoney }}</div>
                  </div>
                  <div class="t_right">
                    <div class="td">长期垫款未还款</div>
                    <div class="tb">{{ deptAdvancesData.loteNoReturnedMoney }}</div>
                  </div>
                </div>
                <div class="table">
                  <div class="t_left">
                    <div class="td">长期冻结额度</div>
                    <div class="tb">{{ deptAdvancesData.freezeLoteMoney }}</div>
                  </div>
                  <div class="t_right">
                    <div class="td">长期可充值</div>
                    <div class="tb">{{ deptAdvancesData.loteRechargeRemainMoney }}</div>
                  </div>
                </div>
                <div class="table">
                  <div class="t_left">
                    <div class="td">特批垫款总额</div>
                    <div class="tb">{{ deptAdvancesData.advancesSpapTotalMoney }}</div>
                  </div>
                  <div class="t_right">
                    <div class="td">特批可充值</div>
                    <div class="tb">{{ deptAdvancesData.spapRechargeRemainMoney }}</div>
                  </div>
                </div>
                <div class="table">
                  <div class="t_left">
                    <div class="td">特批垫款已还款</div>
                    <div class="tb">{{ deptAdvancesData.spapYesReturnedMoney }}</div>
                  </div>
                  <div class="t_right">
                    <div class="td">特批垫款未还款</div>
                    <div class="tb">{{ deptAdvancesData.spapNoReturnedMoney }}</div>
                  </div>
                </div>
                <div class="table">
                  <div class="t_right">
                    <div class="td">累计可充值金额</div>
                    <div class="tb">{{ deptAdvancesData.totalRechargeRemainMoney }}</div>
                  </div>
                </div>
              </template>
              <Empty v-else></Empty>
            </van-collapse-item>
            <van-collapse-item title="垫款信息" name="3">
              <template #title>
                <span class="van-collaps-title">垫款信息</span>
              </template>
              <div v-if="isJudge" style="color: #ff976a; font-size: 13px;">该合同有预期垫款未回款，申请必须进行垫款特批</div>
              <!-- <van-field readonly clickable v-model="form.contPayCompanyName" @click="(id || form.contractId)?showPicker('contPayCompany'):''" label="付款单位" :rules="[{ required: true }]" placeholder="请选择付款单位" required >
                <template #button>
                  <van-button icon="plus" type="info" native-type="button" size="mini" :disabled="!id && !form.contractId" @click.stop="addPayCompany">新增</van-button>
                </template>
              </van-field>
              <van-field v-model="form.payBankAccountNo" label="付款账号" type="number" placeholder="请输入付款账号" />
              <van-field readonly clickable v-model="form.incomeBankName" @click="showPicker('incomeBank')" label="收款银行" :rules="[{ required: true }]" placeholder="请选择收款银行" required />
              <van-field v-model="form.incomeBankNo" label="收款银行账号" type="number" placeholder="请先选择收款银行" disabled /> -->
              <!-- <van-cell title="付款状态" required>
                <template>
                  <van-radio-group v-model="form.payStatus" direction="horizontal">
                    <van-radio name="0" clickable @click="form.payStatus = '0'">未打款</van-radio>
                    <van-radio name="1" clickable @click="form.payStatus = '1'">已打款</van-radio>
                  </van-radio-group>
                </template>
              </van-cell> -->
              <!-- <van-field v-if="form.payStatus == '1'" v-model="form.payDate" readonly clickable name="calendar" label="付款日期" placeholder="点击选择付款日期" @click="showCalendar('payDate')" :rules="[{ required: true }]" required />
              <van-field v-if="form.payStatus == '0'" v-model="form.expectPayDate" readonly clickable name="calendar" label="预计付款日期" placeholder="点击选择预计付款日期" @click="showCalendar('expectPayDate')" :rules="[{ required: true }]" required /> -->
              <van-field v-if="contForm.custSource == '2'" readonly clickable v-model="form.execCustomerName" @click="showPicker('execCustomer')" label="执行客户" placeholder="请选择执行客户" :rules="[{ required: true }]" required >
                <template #button>
                  <van-button icon="plus" type="info" native-type="button" size="mini" @click.stop="addExecCustomer">新增</van-button>
                </template>
              </van-field>
              <van-field v-if="contForm.custSource == '1' || (contForm.custSource == '2' && form.execCustomerId)" readonly clickable v-model="form.projectName" @click="showPicker('project')" label="项目名称" placeholder="请选择项目名称" :rules="[{ required: true }]" required >
                <template #button>
                  <van-button type="primary" native-type="button" size="mini" @click.stop="handlePoint">返点</van-button>
                </template>
              </van-field>
              <template v-if="form.projectId">
                <!-- <van-cell title="账户币 = 垫款金额 * (100%+返点%-代运营服务费%)" style="color: #ee0a24;" /> -->
                <van-field v-model="form.rechargeMoney" label="账户币" placeholder="请输入账户币" @blur="getPayMoney('rechargeMoney',form.rechargeMoney)" :rules="[{ required: true }]" type="number" maxlength="11" required />
                <!-- <van-cell title="垫款金额 = 账户币 / (100%+返点%-代运营服务费%)" style="color: #ee0a24;" /> -->
                <van-field v-model="form.payMoney" label="垫款金额" placeholder="请输入垫款金额" @blur="getPayMoney('payMoney',form.payMoney)" :rules="[{ required: true }]" type="number" maxlength="11" required />
                <van-cell :title="toChineseBig(form.payMoney)" style="color: #1989fa;"  v-if="form.payMoney" />
                <!-- <van-cell :title="payMoneyTip" style="color: #ff976a;" v-if="payMoneyTip" /> -->
                <van-button type="info" block size="mini" style="width: 80%;margin: 0 auto;" native-type="button" @click="imageShow = true">查看【账户币-垫款金额】换算公式</van-button>
              </template>
              <template v-if="contForm.custSource == 1 && contForm.payType == 1">
                <van-field v-model="form.creditCycleTypeName" label="还款账期类型" placeholder="请选择还款账期类型" readonly clickable  @click="showPicker('creditCycleType')" :rules="[{ required: true }]" required/>
                <van-field v-model="form.creditCycleValue" label="还款账期时间(天)" placeholder="请输入还款账期时间(天)" type="digit" maxlength="5" :rules="[{ required: true }]" required @blur="getAdvanceStatusLab" />
              </template>
              <template v-if="executiveList.length > 0 && form.execCustomerId">
                <div v-if="contForm.custSource == 2 && executiveList.find(item => {return form.execCustomerId == item.execCustomerId}).payType == 1">
                  <van-field v-model="form.creditCycleTypeName" label="还款账期类型" placeholder="请选择还款账期类型" readonly clickable  @click="showPicker('creditCycleType')" :rules="[{ required: true }]" required/>
                  <van-field v-model="form.creditCycleValue" label="还款账期时间(天)" placeholder="请输入还款账期时间(天)" type="digit" maxlength="5" :rules="[{ required: true }]" required @blur="getAdvanceStatusLab" />
                </div>
              </template>
              <div v-if="advanceStatusLab" style="color: #ee0a24; font-size: 13px;">提示信息：{{ advanceStatusLab }}</div>
              <van-field v-model="form.rechargeImg" label="客户确认充值图片" placeholder="请点击下方上传客户确认充值图片" :rules="[{ required: true }]" required readonly />
              <van-uploader class="pictureList" v-model="rechargeList" :max-count="1" :after-read="uploadRechargeFiles" :before-read="beforeRead" :before-delete="handleRechargeRemove" @oversize="onOversize" :max-size="10000 * 1024" />
              <van-field v-model="form.advancesReason" label="垫款事由" placeholder="请输入垫款事由" :rules="[{ required: true }]" required />
              <van-field v-if="isJudge" v-model="form.exceedTimeReason" label="逾期原因" placeholder="请输入逾期原因" :rules="[{ required: true }]" required />
              <van-field v-if="isJudge" v-model="form.delayedCommitmentFile" label="延迟还款承诺书" placeholder="请点击下方上传延迟还款承诺书" :rules="[{ required: true }]" required readonly />
              <van-uploader v-if="isJudge" class="pictureList" v-model="pictureList" :max-count="1" :after-read="uploadContractPictureFiles" :before-read="beforeRead" :before-delete="handleContractRemove" @oversize="onOversize" :max-size="10000 * 1024" />
              <van-field v-model="form.remark"
                  autosize
                  label="备注"
                  placeholder="请输入备注"
                  type="textarea"
                  show-word-limit />
            </van-collapse-item>
            <!-- <van-collapse-item title="业务员指定媒介" name="2">
              <template #title>
                <span class="van-collaps-title">业务员指定媒介</span>
              </template>
              <van-checkbox v-model="form.autoConfrim" :checked="form.autoConfrim==1? true:false" true-label="1" false-label="0" shape="square" icon-size="18px" @change="checkChange">审批通过后自动推送媒介确认</van-checkbox>
              <div style="color: #ff976a;margin-top: 5px;font-size: 12px;">提示：当选择此项时，垫款流程审批通过后跳过业务员确认及指定媒介人员；部门和媒介人员必须选择</div>
              <van-field readonly clickable v-model="form.operationDeptName" label="部门" :rules="form.autoConfrim == 1?[{ required: true }]:[]" :required="form.autoConfrim == 1?true:false" placeholder="请选择部门" @click="showCascader('dept')" />
              <van-field readonly clickable v-model="form.operationUserName" label="媒介人员" placeholder="请选择媒介人员" :rules="form.autoConfrim == 1?[{ required: true }]:[]" :required="form.autoConfrim == 1?true:false" @click="form.operationDeptId?showPicker('userName'):''" />
              <div style="display: flex; justify-content: flex-end; padding-top: 10px">
                <van-button size="mini" type="warning" @click="handlePrevious" native-type="button" :disabled="form.autoConfrim == 0">获取上一条记录媒介人员</van-button>
              </div>
            </van-collapse-item> -->
          </van-collapse>
        </van-form>
        <div class="footer">
          <van-button hairline type="defaut" plain @click="dialogCancle">取消</van-button>
          <van-button hairline type="defaut" v-preventReClick plain @click="saveAdvances('0')">保存草稿</van-button>
          <van-button hairline type="defaut" v-preventReClick plain @click="saveAdvances('2')">提交</van-button>
        </div>
      </van-dialog>
      <van-calendar v-model="datePicker.showDate" :min-date="datePicker.minDate" :type="datePicker.type" @confirm="dateConfirm" />
      <van-popup v-model="picker.visible" position="bottom">
        <van-picker :loading="picker.loading" :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
      </van-popup>
      <van-popup v-model="tree.typeTree" position="bottom">
        <van-cascader :title="tree.title" :options="tree.treeList" :field-names="tree.fieldNames" @change="treeChange" @close="tree.typeTree = false" />
      </van-popup>
      <select-contract :show='select_show' @handleCancel='handleCancel' @beforeClose='selectBeforeClose'></select-contract>
      <van-dialog v-model="payCompanyShow" title="付款单位" width="95%" :beforeClose="payCompanyBeforeClose" show-cancel-button>
        <van-form ref="payCompanyForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
          <van-field v-model="payCompanyForm.contPayCompanyName" label="付款单位" placeholder="请输入付款单位" :rules="[{ required: true }]" required />
        </van-form>
      </van-dialog>
      <dialog-executive :show='execCustomerShow' :isAdd="isAddExec" :execCustomerId="form.execCustomerId" :contractId="contractId" @beforeClose='addExecutivBeforeClose'></dialog-executive>

      <van-image-preview v-model="imageShow" :images="imageArr"></van-image-preview>

      <!-- 项目返点信息 -->
      <van-dialog v-model="projectPointVisible" title="项目名称返点" width="95%" style="height:80%;"  :close-on-click-overlay="true" :showConfirmButton = 'false'>
        <van-list v-if="projectPointList.length > 0" style="margin-top: 10px">
          <van-cell v-for="(item,index) in projectPointList" :key="index">
            <div class="flex-between" v-if="item" style="align-items: flex-start">
              <div>
                <div>
                  <span class="key"> 返点百分比值(%)：</span>
                  <span class="value">{{ item.percentage }}%</span>
                </div>
                <div>
                  <span class="key"> 返点消耗(元)：</span>
                  <span class="value" style="color: #ee0a24;">{{ item.useMoney }}(元)</span>
                </div>
                <div style="padding-left:70px;text-indent:-70px;">
                  <span class="key"> 执行时间：</span>
                  <span class="value">{{ item.startTime }}至{{ item.endTime }}</span>
                </div>
              </div>
            </div>
          </van-cell>
        </van-list>
        <Empty v-if="projectPointList.length == 0"></Empty>
      </van-dialog>
    </div>
  </div>
</template>
<script>
import { Toast, Checkbox, Cascader, ImagePreview, Dialog } from 'vant'
import payment from '@/api/cont/payment'
import newContract from '@/api/cont/newContract'
import SelectContract from '../components/SelectContract'
import { getValue } from '@/utils/util'
import { getDicts } from '@/api/system/dict/data'
import DialogExecutive from '../components/DialogExecutive.vue'
import { selectDeptIdByUserList } from '@/api/admi/user'
import Empty from '@/components/common/Empty'
export default {
  name: 'DialogApply',
  components: {
    [Toast.name]: Toast,
    [Checkbox.name]: Checkbox,
    vanCascader: Cascader,
    [ImagePreview.Component.name]: ImagePreview.Component,
    [Dialog.Component.name]: Dialog.Component,
    SelectContract,
    DialogExecutive,
    Empty
  },
  props: {
    show: Boolean,
    isAdd: Boolean,
    contractId: [Number, String],
    modifyObj: Object
  },
  watch: {
    show: {
      handler(val, oldVal) {
        this.DialogShow = val
      }
    },
    contractId: {
      immediate: true,
      async handler(val, oldVal) {
        if (val) {
          this.id = val
          await newContract.getContract(val).then(res => {
            this.contForm = res.data
            if (this.contForm.custSource != 2) {
              payment.judgeAdvances(val).then(res => {
                this.isJudge = res.data != 0
              })
            }
          })
          if (this.contForm.custSource == 1) {
            this.getAdvancesCredit()
          }
          this.getDeptAdvancesData()
          payment.selectByDeptIdMoney({}).then(res => {
            this.amountTotal = res.data.money
          })
          payment.selectByDeptIdMoneyAdd({}).then(res => {
            this.amountTotalAdd = res.data.money
          })
        }
      },
      deep: true
    },
    isAdd: {
      immediate: true,
      handler(val, oldVal) {
        this.isAdd = val
      },
      deep: true
    },
    modifyObj: {
      immediate: true,
      handler(val, oldVal) {
        if (this.isAdd && val) {
          if (val.payMoney) {
            this.form = { ...val }
          } else {
            this.reset()
          }
          this.id = this.form.contractId
          if (this.form.delayedCommitmentFile) {
            this.pictureList = [{
              url: this.form.delayedCommitmentFile
            }]
          } else {
            this.pictureList = []
          }
          if (this.form.rechargeImg) {
            this.rechargeList = [{
              url: this.form.rechargeImg
            }]
          } else {
            this.rechargeList = []
          }
          if (this.form.custSource == 2 && this.form.execCustomerId) {
            this.selectExecCustomer(this.form.execCustomerId)

            payment.listExecutive({ contractId: this.form.contractId }).then(res => {
              this.executiveList = res.rows
              this.form.execCustomerName = this.executiveList.find(item => {
                return item.execCustomerId == this.form.execCustomerId
              }).execCustomerName
            })
          }
          if (this.form.creditCycleType) {
            this.form.creditCycleTypeName = this.formatHandel('creditCycleType', this.form.creditCycleType)
          }
          if (this.form.operationDeptId) {
            payment.listDept().then((response) => {
              const dept = this.getParent(response.data, this.form.operationDeptId)
              this.form.operationDeptName = ''
              dept.map((item) => {
                this.form.operationDeptName += item.label + '/'
              })
              if (this.form.operationDeptName) { this.form.operationDeptName = this.form.operationDeptName.substring(0, this.form.operationDeptName.toString().length - 1) }
            })
            selectDeptIdByUserList(this.form.operationDeptId).then(response => {
              this.deptUserList = response.data
              if (this.deptUserList) { this.form.operationUserName = this.deptUserList.find(item => { return item.userId == this.form.operationUserId }).nickName }
            })
          }
          if (this.form.execCustomerId) {
            payment.isExceedTimeChannel(this.form.execCustomerId).then(res => {
              if (res.code == 200) {
                this.isJudge = res.data != 0
              }
            })
            this.getAdvancesCredit()
          }
        } else if (!this.isAdd && val) {
          this.form = { ...val }
          this.id = this.form.contractId
          if (this.form.delayedCommitmentFile) {
            this.pictureList = [{
              url: this.form.delayedCommitmentFile
            }]
          }
          if (this.form.rechargeImg) {
            this.rechargeList = [{
              url: this.form.rechargeImg
            }]
          }
          if (this.form.custSource == 2 && this.form.execCustomerId) {
            this.selectExecCustomer(this.form.execCustomerId)

            payment.listExecutive({ contractId: this.form.contractId }).then(res => {
              this.executiveList = res.rows
              this.form.execCustomerName = this.executiveList.find(item => {
                return item.execCustomerId == this.form.execCustomerId
              }).execCustomerName
            })
          }
          if (this.form.creditCycleType) {
            this.form.creditCycleTypeName = this.formatHandel('creditCycleType', this.form.creditCycleType)
          }
          if (this.form.operationDeptId) {
            payment.listDept().then((response) => {
              const dept = this.getParent(response.data, this.form.operationDeptId)
              this.form.operationDeptName = ''
              dept.map((item) => {
                this.form.operationDeptName += item.label + '/'
              })
              if (this.form.operationDeptName) { this.form.operationDeptName = this.form.operationDeptName.substring(0, this.form.operationDeptName.toString().length - 1) }
            })
            selectDeptIdByUserList(this.form.operationDeptId).then(response => {
              this.deptUserList = response.data
              if (this.deptUserList) { this.form.operationUserName = this.deptUserList.find(item => { return item.userId == this.form.operationUserId }).nickName }
            })
          }
          if (this.form.execCustomerId) {
            payment.isExceedTimeChannel(this.form.execCustomerId).then(res => {
              if (res.code == 200) {
                this.isJudge = res.data != 0
              }
            })
          }
        }
        // this.form.payStatus = this.form.payStatus.toString()
        // payment.listExecutive({ contractId: this.id }).then(res => {
        //   this.executiveList = res.rows
        //   this.form.flowList.forEach(res => {
        //     if (this.executiveList.find(item => { return item.execCustomerId == res.execCustomerId })) {
        //       res.execCustomerName = this.executiveList.find(item => { return item.execCustomerId == res.execCustomerId }).execCustomerName
        //     }
        //     if (this.options.fundTypeOptions.length > 0) {
        //       if (this.options.fundTypeOptions.find(item => { return item.dictValue == res.fundType })) {
        //         res.fundTypeName = this.options.fundTypeOptions.find(item => { return item.dictValue == res.fundType }).dictLabel
        //       }
        //     }
        //   })
        // })
      }
      // deep: true
    }
  },
  data() {
    return {
      DialogShow: this.show,
      id: this.contractId,
      contForm: {},
      pointList: [],
      select_show: false,
      payCompanyShow: false,
      payCompanyForm: {
        contPayCompanyName: '',
        contractId: ''
      },
      activeNames: ['0', '1', '3'],
      activeNamesP: [0],
      executiveList: [],
      contractList: [],
      contPayCompanyList: [],
      payBankList: [],
      rechargeList: [],
      pictureList: [],
      deptTreeList: [], // 部门树选项
      tree: {
        type: '',
        title: '',
        typeTree: false,
        treeList: [],
        fieldNames: {

        }
      },
      deptUserList: [], // 我方签约人列表集合
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        loading: false
      },
      datePicker: {
        showDate: false,
        minDate: new Date(2010, 0, 1),
        type: 'single',
        formKey: ''
      },
      options: {
        // 业务类型树选项
        incomeBankOptions: [],
        contPartnerTypeOptions: [],
        fundTypeOptions: [],
        creditCycleTypeOptions: []
      },
      authIdArr: [{ authId: '' }],
      form: { ...this.modifyObj } || {
        payMoney: '',
        rechargeMoney: '',
        creditCycleTypeName: '',
        creditCycleType: '',
        creditCycleValue: '',
        advancesReason: '',
        exceedTimeReason: null,
        delayedCommitmentFile: null,
        rechargeImg: null,
        remark: '',
        contractId: '',
        execCustomerId: '',
        autoConfrim: 0,
        operationDeptName: null,
        operationDeptId: null,
        operationUserName: null,
        operationUserId: null,
        submitType: null
      },
      isJudge: false,
      payMoneyTip: '',
      amountTotal: 0,
      amountTotalAdd: 0,
      execCustomerShow: false,
      isAddExec: true,

      projectList: [],
      pointType: null,
      projectPointVisible: false,
      projectPointList: [],

      advancesInfo: {},

      imageShow: false,
      imageArr: [require('../../../assets/images/desktop/formula.png')],
      submitType: null,

      advancesCredit: { creditTotalMoney: null },
      deptAdvancesData: { creditTotalMoney: null },

      advanceStatusLab: null
    }
  },
  async created() {
    // 框架类型
    getDicts('frame_type').then(res => {
      this.options.frameTypeOptions = res.data
    })
    // 客户来源类型
    getDicts('cust_source').then(res => {
      this.options.custSourceOptions = res.data
    })
    // 垫款方式
    getDicts('pay_type').then(res => {
      this.options.payTypeOptions = res.data
    })
    getDicts('sys_money_type').then(res => {
      this.options.fundTypeOptions = this.setDictToInt(res)
    })
    getDicts('credit_cycle_type').then(res => {
      this.options.creditCycleTypeOptions = res.data
    })
    // const that = this
    if (!this.isAdd) {

    }
  },
  methods: {
    // 判断长期垫款还是垫款特批
    async getAdvanceStatusLab() {
      if (this.contractId && this.form.projectId && this.form.payMoney && this.form.creditCycleType && this.form.creditCycleValue) {
        const query = {
          contractId: this.contractId,
          execCustomerId: this.form.execCustomerId || null,
          creditCycleType: this.form.creditCycleType,
          creditCycleValue: this.form.creditCycleValue,
          payMoney: this.form.payMoney
        }
        console.log(query)
        await payment.getAdvanceStatusLab({ ...query }).then(res => {
          if (res.code === 200) {
            this.advanceStatusLab = res.msg
          }
        })
      }
    },
    getAdvancesCredit() {
      let execCustomerId = null
      if (this.contForm.custSource == 2 && this.form.execCustomerId) {
        execCustomerId = this.form.execCustomerId
      }
      payment.getAdvancesCredit({ contractId: this.contForm.contractId || this.contractId, execCustomerId }).then(res => {
        if (res.code === 200 && res.data) {
          this.advancesCredit = res.data
        }
      })
    },
    getDeptAdvancesData() {
      payment.getDeptAdvancesData({ contractId: this.contForm.contractId || this.contractId }).then(res => {
        if (res.code === 200 && res.data) {
          this.deptAdvancesData = res.data
        }
      })
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    getParent(data2, nodeId2) {
      var arrRes = []
      if (data2.length == 0) {
        if (nodeId2) {
          arrRes.unshift(data2)
        }
        return arrRes
      }
      const rev = (data, nodeId) => {
        for (var i = 0, length = data.length; i < length; i++) {
          const node = data[i]
          if (node.id == nodeId) {
            arrRes.unshift(node)
            rev(data2, node.parentId)
            break
          } else {
            if (node.children) {
              rev(node.children, nodeId)
            }
          }
        }
        return arrRes
      }
      arrRes = rev(data2, nodeId2)
      return arrRes
    },
    async showPicker(type, index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
      this.picker.loading = true
      this.picker.columns = []
      this.picker.formKey = type
      const optionItem = type + 'Options'
      if (type === 'userName') {
        // 选择人员
        selectDeptIdByUserList(this.form.operationDeptId).then(response => {
          this.deptUserList = response.data
          this.picker.columns = this.deptUserList.map(item => item.nickName)
          this.picker.loading = false
        })
      } else if (type === 'execCustomer') {
        // if (this.executiveList.length === 0) {
        await payment.listExecutive({ contractId: this.contractId, channelType: this.contForm.channelType }).then(res => {
          this.executiveList = res.rows
        })
        // }
        this.picker.columns = this.executiveList.map((ele) => `${ele.execCustomerName}（${ele.bussUserName}）`)
        this.picker.loading = false
      } else if (type === 'project') {
        if (this.contForm.custSource == 1) {
          await this.getProjectList(1, this.contractId)
        } else if (this.contForm.custSource == 2) {
          await this.getProjectList(2, this.form.execCustomerId)
        }
        this.picker.columns = this.projectList.map((ele) => `【${ele.percentage}%/${ele.calculationMethodStr}】${getValue(ele.projectName)} | ${ele.industryName ? ele.industryName : '-'}`)
        this.picker.loading = false
      } else if (type === 'contract') {
        if (this.contractList.length === 0) {
          await newContract.listPayment({ pageNum: 1, pageSize: 500, contractStatus: 6, payType: 1, orderByColumn: 'createTime', isAsc: 'desc' }).then(res => {
            this.contractList = res.rows
          })
        }
        this.picker.columns = this.contractList.map((ele) => ele.contractName)
        this.picker.loading = false
      } else if (type === 'contPayCompany') {
        // 获取付款单位信息
        // if (this.contPayCompanyList.length == 0) {
        await payment.listPayer({ contractId: this.id || this.form.contractId, orderByColumn: 'createTime', isAsc: 'desc' }).then((response) => {
          this.contPayCompanyList = response.rows
        })
        // }
        this.picker.columns = this.contPayCompanyList.map((ele) => ele.contPayCompanyName)
        this.picker.loading = false
      } else if (type === 'incomeBank') {
        if (this.payBankList.length == 0) {
          await payment.listPayBank({ companyId: this.contForm.companyId }).then(res => {
            if (res.code === 200) {
              this.payBankList = res.rows
            }
          })
        }
        this.payBankList.forEach((ele) => {
          ele.incomeBankName = `${ele.bankName}(${ele.accountNum})`
        })
        this.picker.columns = this.payBankList.map((ele) => ele.incomeBankName)
        this.picker.loading = false
      } else {
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
        this.picker.loading = false
      }
      this.picker.visible = true
    },
    pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      const name = this.picker.formKey + 'Name'
      // const id = this.picker.formKey + 'Id'
      if (this.index || this.index == 0) {
        if (this.picker.formKey === 'execCustomer') {
          this.form.flowList[this.index].execCustomerId = this.executiveList[key].execCustomerId
          this.form.flowList[this.index].execCustomerName = this.executiveList[key].execCustomerName
        } else {
          this.form.flowList[this.index][this.picker.formKey] = this.options[optionItem][key].dictValue
          this.form.flowList[this.index][name] = this.options[optionItem][key].dictLabel
        }
      } else {
        if (this.picker.formKey === 'userName') {
          this.form.operationUserName = this.deptUserList[key].nickName
          this.form.operationUserId = this.deptUserList[key].userId
        } else if (this.picker.formKey === 'execCustomer') {
          this.form.execCustomerId = this.executiveList[key].execCustomerId
          this.form.execCustomerName = this.executiveList[key].execCustomerName
          this.selectExecCustomer(this.form.execCustomerId)
        } else if (this.picker.formKey === 'project') {
          this.form.projectId = this.projectList[key].projectId
          this.form.projectName = this.projectList[key].projectName
          this.selectExecCustomer(this.form.execCustomerId)
        } else if (this.picker.formKey === 'contract') {
          this.form.contractName = this.contractList[key].contractName
          this.form.contractId = this.contractList[key].contractId
          this.form.contractNum = this.contractList[key].contractNum
          payment.listPayer({ contractId: this.form.contractId, orderByColumn: 'createTime', isAsc: 'desc' }).then((response) => {
            this.contPayCompanyList = response.rows
          })
        } else if (this.picker.formKey === 'contPayCompany') {
          this.form.contPayCompanyName = this.contPayCompanyList[key].contPayCompanyName
          this.form.contPayCompanyId = this.contPayCompanyList[key].contPayCompanyId
        } else if (this.picker.formKey === 'incomeBank') {
          this.form.incomeBankName = this.payBankList[key].incomeBankName
          this.form.incomeBankId = this.payBankList[key].bankAccountId
          this.form.incomeBankNo = this.payBankList[key].accountNum
        } else {
          this.form[this.picker.formKey] = this.options[optionItem][key].dictValue
          this.form[name] = this.options[optionItem][key].dictLabel
          if (this.picker.formKey === 'creditCycleType') {
            this.getAdvanceStatusLab()
          }
        }
      }
      this.picker.visible = false
    },
    async getProjectList(type, id) {
      this.pointType = type
      await newContract.listProjectPercentage({ bussType: type, bussId: id }).then(res => {
        if (res.code == 200) {
          this.projectList = res.data
        }
      })
    },
    handlePoint() {
      if (this.pointType == 1) {
        newContract.getRebateList({ contractId: this.contractId, projectId: this.form.projectId }).then(res => {
          this.projectPointList = res.rows
          this.projectPointVisible = true
        })
      } else if (this.pointType == 2) {
        payment.getRebateList({ execCustomerId: this.form.execCustomerId, projectId: this.form.projectId }).then(res => {
          this.projectPointList = res.rows
          this.projectPointVisible = true
        })
      }
    },
    pickerCancel() {
      this.picker.visible = false
    },
    checkChange(val) {
      if (val) {
        this.form.autoConfrim = 1
      } else {
        this.form.autoConfrim = 0
      }
    },
    // 打开联级选择框
    async showCascader(val) {
      if (val === 'dept') {
        if (this.deptTreeList.length == 0) {
          await payment.listDept().then((response) => {
            this.deptTreeList = response.data
          })
        }
        this.tree = {
          type: val,
          title: '请选择部门',
          typeTree: true,
          treeList: this.deptTreeList,
          fieldNames: {
            text: 'label', value: 'id', children: 'children'
          }
        }
      }
    },
    treeChange(obj) {
      if (this.tree.type === 'dept') {
        this.form.operationDeptId = obj.value
        this.form.operationDeptName = obj.selectedOptions.map((option) => option.label).join('/')
      }
    },
    showCalendar(type) {
      this.datePicker.type = 'single'
      this.datePicker.formKey = type
      this.datePicker.showDate = true
    },
    dateConfirm(date) {
      // this.minDate = date
      this.form[this.datePicker.formKey] = this.formatDate(date)
      this.datePicker.showDate = false
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    },
    getSum(val, index) {
      if (index || index == 0) {
        if (val === 'advancesMoney' && this.form.contPayAgreeList[this.index][val].indexOf('.') != -1) {
          this.form.contPayAgreeList[this.index][val] = Number(this.form.contPayAgreeList[this.index][val]).toFixed(2)
        }
        if (val === 'payMoney' && this.form.flowList[index][val].indexOf('.') != -1) {
          this.form.flowList[index][val] = Number(this.form.flowList[index][val]).toFixed(2)
        }
      } else {
        if (this.form[val].indexOf('.') != -1) {
          this.form[val] = Number(this.form[val]).toFixed(2)
        }
        // if (this.isJudge) {
        //   this.payMoneyTip = '合同已逾期必须进行特批审核.'
        // } else {
        //   if (val === 'payMoney' && Number(this.form[val]) > 50000) {
        //     this.payMoneyTip = '您的垫款金额 > 5万,需进行垫款特批流程审核.'
        //   } else if (val === 'payMoney' && Number(this.form[val]) <= 50000) {
        //     this.payMoneyTip = '您的垫款金额 ≤ 5万,需事业部负责人审核.'
        //   }
        // }
        // this.amountWords = this.toChineseBig(this.form.contractMoney)
      }
    },
    async getPayMoney(type, val) {
      if (type == 'payMoney') {
        if (this.isJudge) {
          this.payMoneyTip = '合同已逾期必须进行特批审核.'
        } else {
          if (Number(this.form[type]) > 50000) {
            this.payMoneyTip = '您的垫款金额 > 5万,需进行垫款特批流程审核.'
          } else if (Number(this.form[type]) <= 50000) {
            this.payMoneyTip = '您的垫款金额 ≤ 5万,需事业部负责人审核.'
          }
        }
        if (this.form.execCustomerId) {
          await payment.getPayMoney({ payMoney: val, contractId: this.contractId, projectId: this.form.projectId, execCustomerId: this.form.execCustomerId }).then(res => {
            if (res.code == 200) {
              this.form.rechargeMoney = res.data
              this.$set(this.form)
            } else {
              Toast.fail(res.msg)
            }
          })
        } else {
          await payment.getPayMoney({ payMoney: val, contractId: this.contractId, projectId: this.form.projectId }).then(res => {
            if (res.code == 200) {
              this.form.rechargeMoney = res.data
              this.$set(this.form)
            } else {
              Toast.fail(res.msg)
            }
          })
        }
      } else if (type == 'rechargeMoney') {
        if (this.form.execCustomerId) {
          await payment.getPayMoney({ rechargeMoney: val, contractId: this.contractId, projectId: this.form.projectId, execCustomerId: this.form.execCustomerId }).then(res => {
            if (res.code == 200) {
              this.form.payMoney = res.data
              this.$set(this.form)
            } else {
              Toast.fail(res.msg)
            }
          })
        } else {
          await payment.getPayMoney({ rechargeMoney: val, contractId: this.contractId, projectId: this.form.projectId }).then(res => {
            if (res.code == 200) {
              this.form.payMoney = res.data
              this.$set(this.form)
            } else {
              Toast.fail(res.msg)
            }
          })
        }
      }
      await this.getAdvanceStatusLab()
    },
    addExecCustomer() {
      this.isAddExec = true
      this.execCustomerShow = true
    },
    addExecutivBeforeClose() {
      this.form.rechargeMoney = ''
      this.form.payMoney = ''
      this.execCustomerShow = false
    },
    async selectExecCustomer(e) {
      if (e) {
        payment.isExceedTimeChannel(e).then(res => {
          if (res.code == 200) {
            this.isJudge = res.data != 0
            // if (this.isJudge) {
            //   payment.listAdvances({ isExpectDate: 1, contractId: val }).then(response => {
            //     this.overdueList = response.rows
            //     this.overdueLoading = false
            //   })
            // }
          }
        })
        this.getAdvancesCredit()
        if (this.contForm.payType == 2) {
          await payment.getExecutive(e).then(res => {
            if (res.code == 200) {
              this.contForm.advancesMoney = res.data.advancesMoney
              this.contForm.creditTotalMoney = res.data.creditTotalMoney
              this.contForm.creditCycleType = res.data.creditCycleType
              this.contForm.creditCycleValue = res.data.creditCycleValue
            }
          })
        }
        if (this.contForm.payType == 2) {
          await payment.getExecutive(e).then(res => {
            if (res.code == 200) {
              this.advancesInfo = res.data
              this.advancesInfo.creditCycleTypeName = this.formatHandel('creditCycleType', this.advancesInfo.creditCycleType)
              this.form.creditCycleType = res.data.creditCycleType
              this.form.creditCycleTypeName = this.formatHandel('creditCycleType', this.form.creditCycleType)
              this.form.creditCycleValue = res.data.creditCycleValue
              this.$set(this.form)
            }
          })
        }
      }
      // this.form.rechargeMoney = ''
      // this.form.payMoney = ''
    },
    addExecutive() {
      this.form.flowList.push({
        execCustomerId: null,
        execCustomerName: null,
        fundType: null,
        authIds: null,
        payMoney: null
      })
      const res = this.activeNamesP.some(item => {
        return this.form.flowList.length - 1 === item
      })
      if (res === false) {
        this.activeNamesP.push(this.form.flowList.length - 1)
      }
    },
    delExecutive(index) {
      if (this.form.flowList.length > 0) {
        this.form.flowList.splice(index, 1)
      }
    },
    showContList() {
      this.select_show = true
    },
    handleCancel() {
      this.select_show = false
    },
    selectBeforeClose(val) {
      this.form.contractName = val.contractName
      this.form.contractId = val.contractId
      this.form.contractNum = val.contractNum
      this.form.companyName = val.companyName
      // payment.listPayer({ contractId: this.form.contractId, orderByColumn: 'createTime', isAsc: 'desc' }).then((response) => {
      //   this.contPayCompanyList = response.rows
      // })
      payment.getDataByContractId(this.form.contractId).then((response) => {
        if (response.data && response.data.authIds) {
          this.authIdArr = []
          response.data.authIds.split(',').map(item => {
            this.authIdArr.push({ authId: item })
          })
        }
        // else {
        //   this.authIdArr.push({ authId: '' })
        // }
      })
      this.select_show = false
    },
    addPayCompany() {
      this.payCompanyShow = true
      this.payCompanyForm = {
        contPayCompanyName: null,
        contractId: this.id || this.form.contractId
      }
    },
    async payCompanyBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.payCompanyForm.validate()
          await payment.addPayer(this.payCompanyForm)
            .then((res) => {
              this.form.contPayCompanyId = res.data.contPayCompanyId
              this.form.contPayCompanyName = res.data.contPayCompanyName
              Toast.success('添加成功')
              setTimeout(() => {
                this.payCompanyShow = false
              }, 500)
            }).catch(() => {})
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        done()
        this.payCompanyShow = false
      }
    },
    addAuthId() {
      const obj = { authId: '' }
      this.authIdArr.push(obj)
      // this.$set(this.authIdArr)
    },
    delAuthId(index) {
      this.authIdArr.splice(index, 1)
    },
    // async beforeClose(type, done) {
    //   if (type === 'confirm') {
    //     if (Number(this.form.payMoney) + Number(this.amountTotal) > 500000) {
    //       Toast.fail('事业部总垫款金额不能超过50万')
    //       return done(false)
    //     }
    //     if (this.isAdd) {
    //       if (this.id) {
    //         this.form.contractId = this.id
    //       }
    //       try {
    //         await this.$refs.form.validate()
    //         await payment.addAdvances(this.form)
    //         await this.reset()
    //           .then(() => {
    //             Toast.success('添加成功')
    //             setTimeout(() => {
    //               this.$emit('beforeClose', '')
    //             }, 500)
    //           }).catch(() => {})
    //         done()
    //       } catch (err) {
    //         return done(false)
    //       }
    //       return done(false)
    //     } else {
    //       try {
    //         await this.$refs.form.validate()
    //         await payment.updateAdvances(this.form)
    //         await this.reset()
    //           .then(() => {
    //             Toast.success('修改成功')
    //             setTimeout(() => {
    //               this.$emit('beforeClose', '')
    //             }, 500)
    //           }).catch(() => {})
    //         done()
    //       } catch (err) {
    //         return done(false)
    //       }
    //       return done(false)
    //     }
    //   } else {
    //     done()
    //     this.$emit('handleAdvancesCancel')
    //   }
    // },
    // 获取上一条记录媒介人员
    handlePrevious() {
      payment.getLastInfo(1).then(res => {
        if (res.code == 200) {
          this.form.operationDeptId = res.data.operationDeptId
          this.form.operationUserId = res.data.operationUserId
          // selectDeptIdByUserList(this.form.operationDeptId).then(response => {
          //   this.userOptions = response.data
          //   this.$set(this.form)
          // })
          if (this.form.operationDeptId) {
            payment.listDept().then((response) => {
              const dept = this.getParent(response.data, this.form.operationDeptId)
              this.form.operationDeptName = ''
              dept.map((item) => {
                this.form.operationDeptName += item.label + '/'
              })
              if (this.form.operationDeptName) { this.form.operationDeptName = this.form.operationDeptName.substring(0, this.form.operationDeptName.toString().length - 1) }
            })
            selectDeptIdByUserList(this.form.operationDeptId).then(response => {
              this.deptUserList = response.data
              if (this.deptUserList) { this.form.operationUserName = this.deptUserList.find(item => { return item.userId == this.form.operationUserId }).nickName }
            })
          }
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    async saveAdvances(val) {
      const that = this
      // if (Number(this.form.payMoney) > 500000) {
      //   Toast.fail('垫款金额不能超过50万')
      //   return
      // }
      if (this.form.custSource == 2 && !this.form.execCustomerId) {
        Toast.fail('请选择执行客户')
        return false
      }
      this.isAddExec = false
      if (val == '2') {
        if (this.contractId) {
          this.form.contractId = this.contractId
        }
        this.form.checkStatus = null
        this.form.submitType = 1
        await this.$refs.form.validate()
        await payment.isAdvancesApproval(this.form).then(res => {
          if (res.code === 200) {
            if (res.data) {
              Dialog.confirm({
                title: '警告',
                message: '提示：该合同或执行客户已提交垫款申请在审批中，是否继续提交申请？'
              })
                .then(() => {
                  that.trueSaveAdvances()
                })
            } else {
              that.trueSaveAdvances()
            }
          }
        })
      } else {
        this.form.checkStatus = 0
        this.form.submitType = 0
        this.trueSaveAdvances()
      }
      // if (Number(this.form.payMoney) + Number(this.amountTotal) > 500000) {
      //   Toast.fail('事业部总垫款金额不能超过50万')
      //   return
      // }
    },
    async trueSaveAdvances() {
      if (this.isAdd) {
        payment.addAdvances(this.form).then(res => {
          if (res.code == 200) {
            this.reset()
            Toast.success('添加成功')
            setTimeout(() => {
              // this.$emit('beforeClose', '')
              this.$router.push({
                path: '/cont/advances/approvalList',
                query: {
                  active: res.data
                }
              })
            }, 500)
          } else {
            Toast.fail(res.msg)
            setTimeout(() => {
              if (this.form.execCustomerId && res.msg == '请先完善执行客户垫款总金额！') {
                this.execCustomerShow = true
              }
            }, 500)
          }
        })
      } else {
        await payment.updateAdvances(this.form).then(res => {
          if (res.code == 200) {
            this.reset()
            Toast.success('修改成功')
            setTimeout(() => {
              // this.$emit('beforeClose', '')
              this.$router.push({
                path: '/cont/advances/approvalList',
                query: {
                  active: res.data
                }
              })
            }, 500)
          } else {
            Toast.fail(res.msg)
            setTimeout(() => {
              if (this.form.execCustomerId && res.msg == '请先完善执行客户垫款总金额！') {
                this.execCustomerShow = true
              }
            }, 500)
          }
        })
      }
    },
    dialogCancle() {
      this.$emit('handleAdvancesCancel')
    },
    // 清空表单
    async reset() {
      this.pictureList = []
      this.form = {
        payMoney: '',
        creditCycleTypeName: '',
        creditCycleType: '',
        creditCycleValue: '',
        rechargeMoney: '',
        advancesReason: '',
        exceedTimeReason: null,
        delayedCommitmentFile: null,
        rechargeImg: null,
        remark: '',
        contractId: '',
        autoConfrim: 0,
        operationDeptName: null,
        operationDeptId: null,
        operationUserName: null,
        operationUserId: null
      }
    },
    // 返回布尔值
    beforeRead(file) {
      const imgArr = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp', 'image/svg+xml', 'image/vnd.adobe.photoshop']
      if (!imgArr.some((item) => { return file.type === item })) {
        Toast('请上传 图片 文件')
        return false
      }
      return true
    },
    onOversize(file) {
      Toast('文件大小不能超过 10mb')
    },
    handleRechargeRemove(file) {
      this.form.rechargeImg = ''
      this.rechargeList = []
      return true
    },
    async uploadRechargeFiles(file) {
      const _file = file.file
      // 通过 FormData 对象上传文件
      var formData = new FormData()
      formData.append('file', _file)
      await payment.uploadContractFile(formData)
        .then((res) => {
          if (res.code === 200) {
            this.form.rechargeImg = res.url
            this.rechargeList = []
            this.rechargeList.push({ url: res.url })
            Toast.success(res.msg)
          } else {
            Toast.fail(res.msg)
          }
        })
        .catch(function (error) {
          console.error(error)
        })
    },
    handleContractRemove(file) {
      // const picture = this.form.payImg
      // if (picture.indexOf(file.url) == 0) {
      //   if (picture.indexOf(',') == -1) {
      //     picture = null
      //   } else {
      //     picture = picture.replace(file.url + ',', '')
      //   }
      // } else {
      //   picture = picture.replace(',' + file.url, '')
      // }
      // this.form.fileList[this.index].url = picture
      // console.log(this.form.fileList[this.index].url.split(','))
      this.form.delayedCommitmentFile = ''
      this.pictureList = []
      return true
      // if (this.form.fileList[this.index].url != '' && this.form.fileList[this.index].url != null) {
      //   const payCaptures = this.form.fileList[this.index].url.indexOf(',') > -1 ? this.form.fileList[this.index].url.split(',') : [this.form.fileList[this.index].url]
      //   payCaptures.forEach((element) => {
      //     this.form.fileList[this.index].pictureList.push({
      //       url: element
      //     })
      //   })
      // }
    },
    async uploadContractPictureFiles(file) {
      const _file = file.file
      // 通过 FormData 对象上传文件
      var formData = new FormData()
      formData.append('file', _file)
      await payment.uploadContractFile(formData)
        .then((res) => {
          if (res.code === 200) {
            // let picture = res.url
            // if (picture != null && this.form.payImg != '') {
            //   picture = res.url
            // } else {
            //   picture = res.url
            // }
            this.form.delayedCommitmentFile = res.url
            // console.log(this.form.fileList[this.index].url)
            // console.log(this.form.fileList[this.index].url.split(','))
            // const payCaptures = picture.split(',')
            // this.form.fileList[this.index].pictureList = []
            // payCaptures.forEach((element) => {
            //   this.form.fileList[this.index].pictureList.push({
            //     url: element
            //   })
            // })
            this.pictureList = []
            this.pictureList.push({ url: res.url })
            Toast.success(res.msg)
          } else {
            Toast.fail(res.msg)
          }
        })
        .catch(function (error) {
          console.error(error)
        })
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
// .editClue /deep/.van-dialog__content {
//   height: 80%;
// }
.link{
  height: 80px;
  margin-bottom: 60px;
}
.pictureList{
  margin-left: 30px;
  margin-top: 10px;
}
.van-collaps-title{
  color: #1989fa;
  font-size: 30px;
}
.van-cell__value {
  min-width: 71%; //可根据自己需求设定值
  text-align: left;
}
/deep/.van-list{
  padding: 0;
  .flex-between{
    div{
      max-width: 100% !important;
    }
  }
}
.skzxkh{
  /deep/.van-collapse-item__content{
    padding: 10px;
  }
}
.editClue /deep/.van-dialog__content {
  height: 82%;
}
.editClue /deep/.van-dialog__footer{
  display: none;
}
.footer{
  display: flex;
  margin-top: -10px;
  .van-button{
    width: 33.3%;
    border: 1px #f4f4f4 solid;
  }
}
.bigMoney{
  color: #409EFF;
}

/deep/ .van-collapse-item__content{
  padding: 0 10px;
}
.table:first-child {
  border-top: 2px solid #ddd;
}
.table {
  display: flex;
  // align-items: center;
  border: 2px solid #ddd;
  border-top: none;
  line-height: 50px;
  font-size: 24px;
  // text-align: center;
  color: #666;
  .t_left{
    display: flex;
    border-right: 1px solid #ddd;
    width: 50%;
  }
  .t_right{
    display: flex;
    width: 50%;
  }
  .td {
    width: 53%;
    border-top: 2px solid #ddd;
    border-right: 2px solid #ddd;
    padding-left: 8px;
    background-color: #f7f8fc;
  }
  .td:first-child {
    border-top: none;
  }
  // .td:last-child {
  //   border-right: none;
  // }
  .tb{
    width: 50%;;
    padding-left: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
